import { Directive, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { throttleTime } from "rxjs/operators";

@Directive({
  selector: "[click-throttle]"
})
export class ClickThrottleDirective implements OnInit, OnDestroy {
  constructor() {}
  subscription: Subscription;
  clickSubject = new Subject();

  @Input()
  throttleTime: number = 500;
  @Output()
  throttleClick = new EventEmitter();

  @HostListener("click", ["$event"])
  clickEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    this.clickSubject.next(event);
  }

  ngOnInit() {
    this.subscription = this.clickSubject.pipe(throttleTime(this.throttleTime)).subscribe(e => this.throttleClick.emit(e));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
